import { ForwardedRef, forwardRef } from 'react';
import { Props } from '@components/toggle/src/toggle.type';
import { ToggleButton } from '@components/toggle/src/toggle-button';
import classNames from 'classnames';

export const Toggle = forwardRef(
  (
    { value, onChange, isEnabledText, isNotEnabledText, disabled = false, switchValues }: Props,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: ForwardedRef<unknown>
  ) => {
    return (
      <span className={classNames('flex flex-row shadow-sm rounded-full w-max bg-tertiary')}>
        {!switchValues && (
          <ToggleButton enabled={!value} setEnabled={() => onChange(false)} disabled={disabled}>
            {isEnabledText}
          </ToggleButton>
        )}
        <ToggleButton enabled={value} setEnabled={() => onChange(true)} disabled={disabled}>
          {isNotEnabledText}
        </ToggleButton>
        {switchValues && (
          <ToggleButton enabled={!value} setEnabled={() => onChange(false)} disabled={disabled}>
            {isEnabledText}
          </ToggleButton>
        )}
      </span>
    );
  }
);
